import { render, staticRenderFns } from "./MTitle.vue?vue&type=template&id=36bd3f2c"
import script from "./MTitle.vue?vue&type=script&lang=js"
export * from "./MTitle.vue?vue&type=script&lang=js"
import style0 from "./MTitle.vue?vue&type=style&index=0&id=36bd3f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports